module.exports = __webpack_public_path__ + "static/media/cumin.057b00d2.jpg";